import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AuthService } from 'src/app/core-services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PlanVM } from 'src/app/models/PlansVM';
import { $ } from 'protractor';
import { PlanService } from 'src/app/public/landing/services/plan.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-plan-list',
  templateUrl: './plan-list.component.html',
  styleUrls: ['./plan-list.component.scss']
})
export class PlanListComponent implements OnInit {

  requestVM: AdminViewModel;
  plandetails: any;
  plandata: any;
  totalcount: number = 0;
  submitted:boolean=false;
  constructor(private toastr: ToastrService,
     private fb: FormBuilder, private authenticationService: AuthService, private spinner: NgxSpinnerService,
     private planService: PlanService,
     private modalService: NgbModal) { }

  @ViewChild('closeplanpopup') closeplanpopup: ElementRef;
  @ViewChild('planModal', { static: false }) planModal: any;
    modalRef: NgbModalRef | null = null;

  ngOnInit() {
    this.requestVM = new AdminViewModel();
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.getplanList();
  }

  planEditform = this.fb.group({
    planname: ['', [Validators.required, Validators.maxLength(30)]],
    plancost: ['', [Validators.required, Validators.maxLength(10)]],
    searchpermissionids: ['', Validators.required],
    planid: ['', Validators.required],
    isPlanActive:['',Validators.required],
    description: ['', Validators.required]
  });
  get fn() { return this.planEditform.controls; }

  public hasError = (controlName: string, errorName: string) => {
    return this.planEditform.controls[controlName].hasError(errorName);
  }
  getplanList() {
    if (this.requestVM != null && this.requestVM.pageNo > 0 && this.requestVM.pageSize > 0) {
      this.spinner.show();
      this.planService.GetPlanList(this.requestVM).subscribe((response: any) => {
        if (response != null && response.data != null) {
          this.plandata = response.data;
          this.totalcount = response.totalRecords;
          this.spinner.hide();
        }
        this.spinner.hide();
      })
    }
  }

  openPlanModal(planId: any) {
    this.getPlandetails(planId)
    this.modalRef = this.modalService.open(this.planModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  paginate(event) {
    this.requestVM.pageNo = event.page + 1;
    this.requestVM.pageSize = event.rows;
    this.getplanList();
  }

  filterSearch(searchText) {
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.requestVM.searchText = searchText;
    this.getplanList();
  }
  
  getPlandetails(planid) {
    if (planid != 'undefined' && planid != null) {
      this.spinner.show()
      this.planService.GetPlanDetails(planid).subscribe((response: any) => {
        if (response != null && response.data != null) {
          this.planEditform.controls.planname.setValue(response.data.planName);
          this.planEditform.controls.plancost.setValue(response.data.planCost);
          this.planEditform.controls.searchpermissionids.setValue(response.data.planSerachPermissionIds);
          this.planEditform.controls.planid.setValue(response.data.planId);
          this.planEditform.controls.isPlanActive.setValue(response.data.isPlanActive);
          this.planEditform.controls.description.setValue(response.data.description);
          this.plandetails = response.data.planCatDetails;          
          this.spinner.hide();
        }
      })
    }
  }
  
  handleChange(event, CatId) {
    var values = [];
    if (this.planEditform.controls.searchpermissionids.value != "") {
      values = this.planEditform.controls.searchpermissionids.value.split(',');
    }
    if (event.checked) {      
      values.push(CatId);
      this.planEditform.controls.searchpermissionids.setValue(values.toString());      
    }
    else {
      var index = values.findIndex(x => x == CatId);
      values.splice(index, 1);      
      this.planEditform.controls.searchpermissionids.setValue(values.toString());      
    }
  }

  UpdatePlan()
  {
    this.submitted = true;       
    if (this.planEditform.invalid) {
          this.toastr.warning('Please Enter Enter the Reason.', 'Oops !');
      return;
    }
    else {
      this.spinner.show();
      var planmodel: any = new PlanVM();
      planmodel.PlanName = this.planEditform.controls.planname.value;
      planmodel.description = this.planEditform.controls.description.value;
     // planmodel.PlanCost = this.planEditform.controls.plancost.value;
      if(this.planEditform.controls.plancost.value != null && this.planEditform.controls.plancost.value != '')
      {
        planmodel.PlanCost = parseInt(this.planEditform.controls.plancost.value);
      }      
      planmodel.PlanSerachPermissionIds = this.planEditform.controls.searchpermissionids.value;
      planmodel.PlanId = this.planEditform.controls.planid.value;
      planmodel.IsPlanActive = this.planEditform.controls.isPlanActive.value;          
      this.planService.UpdatePlan(planmodel).subscribe((response: any) => {
        if (response != null && response.data != null) {                 
          this.planEditform.reset();          
          this.toastr.success('Plan has been updated..!', '');
          this.modalRef.close();
          this.spinner.hide();   
          this.getplanList();     
        }
        else{
          //this.planEditform.reset();
          this.toastr.error('Plan not updated!', 'Oops');          
          this.spinner.hide();
        }
      })          
    }
  }
}
